import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { handleGetAreaScopeList } from './areaScopeThunk';
import { IAreaScopeList } from '~/utils/interface/areaScope';

export interface AreaScopeState {
  needRefreshData: boolean;
  areaScopes: Array<IAreaScopeList>;
  areaScopeId: string;
  openAlertDelete: boolean;
  menuSelectedId: string | undefined;
  openAlertDeleteMoisturePoints: boolean;
}

const initialState: AreaScopeState = {
  needRefreshData: false,
  areaScopes: [],
  areaScopeId: '',
  openAlertDelete: false,
  openAlertDeleteMoisturePoints: false,
  menuSelectedId: undefined,
};

const areaScopeSlice = createSlice({
  name: 'areaScope',
  initialState,
  reducers: {
    changeNeedRefreshData(state, action: PayloadAction<boolean>) {
      state.needRefreshData = action.payload;
    },
    changeAreaScopeId(state, action: PayloadAction<string>) {
      state.areaScopeId = action.payload;
    },
    changeOpenAlertDelete(state, action: PayloadAction<boolean>) {
      state.openAlertDelete = action.payload;
    },
    changeOpenAlertDeleteMoisturePoints(state, action: PayloadAction<boolean>) {
      state.openAlertDeleteMoisturePoints = action.payload;
    },
    changeMenuSelectId(state, action: PayloadAction<string | undefined>) {
      state.menuSelectedId = action.payload;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(handleGetAreaScopeList.pending, (_state, _action) => {})

      .addCase(handleGetAreaScopeList.fulfilled, (state, action) => {
        state.areaScopes = [...action.payload.responses];

        state.needRefreshData = false;
      })

      .addCase(handleGetAreaScopeList.rejected, (_state, _action) => {});
  },
});

export const areaScopeActions = areaScopeSlice.actions;

const areaScopeReducer = areaScopeSlice.reducer;
export default areaScopeReducer;
